import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Cookie } from 'lucide-react';

const COOKIE_KEY = 'vdg_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(COOKIE_KEY, 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-in fade-in duration-500 bg-black/20 backdrop-blur-sm"
      data-testid="cookie-banner"
    >
      <div className="max-w-lg w-full bg-card border border-border rounded-xl shadow-2xl p-5 sm:p-6 flex flex-col gap-4">
        <div className="flex items-start gap-3">
          <Cookie className="h-8 w-8 text-amber-500 shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-foreground mb-1">Este site utiliza cookies</p>
            <p className="text-xs text-muted-foreground leading-relaxed">
              Utilizamos cookies essenciais para o funcionamento da plataforma e cookies analíticos para melhorar sua experiência. Ao clicar em &ldquo;Aceitar&rdquo;, você concorda com o uso de cookies conforme nossa{' '}
              <Link to="/privacidade" className="text-primary hover:underline font-medium">Política de Privacidade</Link>.
            </p>
          </div>
        </div>
        <div className="flex gap-2 justify-end">
          <Button variant="outline" size="sm" onClick={handleReject} className="rounded-lg text-xs px-5" data-testid="cookie-reject-btn">
            Rejeitar
          </Button>
          <Button size="sm" onClick={handleAccept} className="rounded-lg text-xs px-5" data-testid="cookie-accept-btn">
            Aceitar
          </Button>
        </div>
      </div>
    </div>
  );
}
